import LocationsMap from './locationsmap';
import React from 'react';

let gmdv = require(`../../../../ghc_config`);

function LocationsMapContainer(props) {
	return (
		<LocationsMap
			googleMapURL={gmdv.googleMapURL()}
			loadingElement={<div style={{ height: `100%` }} />}
			containerElement={<div style={{ height: `490px`, width: `100%` }} />}
			mapElement={<div style={{ height: `100%` }} />}
			//  Drupal data
			locations={props.locations}
			//  state values
			positionWindow={props.positionWindow}
			startPosition={props.startPosition}
			radius={props.radius}
			stateCheck={props.stateCheck}
			//  handlers'
			searchtype={props.searchtype}
			handleRadiusChange={props.handleRadiusChange}
			handleToggleOpen={props.handleToggleOpen}
			handleToggleCloseAll={props.handleToggleCloseAll}
			//  starsdata
			allPracticemaxRatings={props.allPracticemaxRatings}
		/>
	);
}

export default LocationsMapContainer